import { useContext, useEffect, useRef } from "react";
import { useLocation, UNSAFE_RouteContext } from "react-router-dom";
import { initGA, trackPageView } from "../GoogleAnalytics";

// source: https://stackoverflow.com/a/73723495
function usePathPattern() {
    let lastRouteContext = useContext(UNSAFE_RouteContext);
    while (lastRouteContext.outlet) lastRouteContext = lastRouteContext.outlet.props.routeContext;
    return lastRouteContext.matches
        .map(({ route: { path } }) => path)
        .filter(Boolean)
        .join("/")
        .replaceAll(/\/\*?\//g, "/");
}

export const usePageTracking = () => {
    const location = useLocation();
    const routePattern = usePathPattern();
    const initGAPromise = useRef<Promise<void>>();

    useEffect(() => {
        initGAPromise.current = initGA();
    }, []);

    useEffect(() => {
        initGAPromise.current?.then(() => {
            trackPageView(location.pathname + location.search, { content_group: routePattern });
        });
    }, [location]);
};
